import { initWidget } from './widget';
import endpoints from './widget/define/endpoints';

import SearchForm from './widget/component/SearchForm/SearchForm';
import HistoryList from './widget/component/HistoryList';
//import SmartSearchForm from './widget/component/SearchForm/SmartSearchForm';
//import SmartSearchTermsAutocomplete from './widget/component/SearchForm/SmartSearchTermsAutocomplete';

const props = {
    endpoints,
};

let HeaderModule = null;
let AvatarModule = null;
let AddToWishListModule = null;

const loadedDeferredModules = loadDeferredModules();
loadedDeferredModules.then(() => InitDeferredModules());

const initSpecificPageWidgets = () => {
    initWidget('search-form', SearchForm, props);
    //initWidget('smart-search-form', SmartSearchForm, props);
    //initWidget('smart-search-terms-autocomplete', SmartSearchTermsAutocomplete, props);
    initWidget('history-list', HistoryList, props);
};

const InitDeferredModules = () => {
    initWidget('avatar', AvatarModule.default, props)
    initWidget('add-to-wish-list', AddToWishListModule.default, props)
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSpecificPageWidgets.bind(this));
} else {
    initSpecificPageWidgets();
}

async function loadDeferredModules() {
    AvatarModule = await import('./widget/component/Avatar/Avatar')
    AddToWishListModule = await import('./widget/component/AddToWishList')
}